webpackJsonp([56384549829646],{

/***/ 514:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mihail Eric","subtitle":"Engineer, researcher, educator.","copyright":"Copyright","menu":[{"label":"Blog","path":"/blog/"},{"label":"Projects","path":"/projects/"},{"label":"Teaching","path":"/teaching/"}],"author":{"name":"Mihail Eric","email":"mihail911@gmail.com","twitter":"mihail_eric","github":"mihail911","linkedin":"mihaileric"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/The-Emperor-Has-No-Clothes/","tagSlugs":["/tags/python/","/tags/ai/","/tags/llm/","/tags/coding-agents/","/tags/tutorial/"]},"frontmatter":{"title":"The Emperor Has No Clothes: How to Code Claude Code in 200 Lines of Code","date":"2025-01-07","description":"The core of tools like Claude Code, Cursor, and Warp isn't magic. It's about 200 lines of straightforward Python. Let's build one from scratch.","tags":["python","ai","llm","coding-agents","tutorial"]}}}]}},"pathContext":{"tag":"ai"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-ai-9d141d2aef4516d7e9ed.js